<template>
    <div class="container-fluid py-4 px-4">

        <div class="border border-1 rounded-3 p-3 mb-3 ">
            <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
                <i class="bi bi-gear-fill display-4 text-primary"></i>
                <div>
                    <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
                        LISTADO DE POSTULANTES
                    </p>
                    <p class="mb-0 tituloResaltado fs-4 fw-bold">
                        BUSQUEDA DE INFORMACION
                    </p>
                </div>
            </div>
        </div>


        <div class="d-flex flex-wrap gap-2 mb-3">

            <button @click="listado" v-if="BotonTabla" class="btn btn-danger text-white">
                <i class="bi bi-skip-backward"></i>
            </button>
            <!-- <button v-b-modal.modal-center @click="buscador" class="btn btn-success text-white">
                <i class="bi bi-person-add"></i>
            </button> -->

            <button v-if="BotonTabla" v-b-modal.modal-center class="btn btn-warning text-white"
                title="MODIFICAR POSTULANTE">
                <i class="bi bi-person-fill-gear"></i>
            </button>

            <!-- MODAL -->
            <!-- <b-modal id="modal-center" centered title="MODIFICAR USUARIO" @ok="realizarAccionAlAceptar">
                <select @change="selectores = $event.target.value" class="form-select">
                    <option disabled selected>.....</option>
                    <option v-for="items in combito" :key="items.id" :value="items.idUsuario">
                        {{ items.usuCodigo }}
                    </option>
                </select>
            </b-modal> -->
        </div>

        <div class="border border-1 rounded-3 p-3 mb-3 ">

            <div v-if="postulanteCondicion" class="mx-1 mx-md-3">

                <!-- === ALERTA === -->
                <div class="col-12">
                    <div v-if="alerta" class="alert alert-danger mt-2">
                        ¡Éxito! Registro eliminado correctamente.
                    </div>
                </div>

                <!-- === MENSAJES === -->
                <div v-if="mostrarInput">
                    <p v-if="alertita" class="text-danger fw-semibold mt-2">
                        ¡ALERTA! No se encontraron registros con los criterios de búsqueda.
                    </p>
                </div>

                <!-- === BUSCADOR === -->
                <div class="d-flex justify-content-end mt-2">
                    <span class="input-group-text mt-3 buscar-estiloCuadrado">
                        <i class="bi bi-search"></i>
                    </span>
                    <input class="form-control form-control-lg w-25 mt-3 me-2 buscar-estiloCuadrado"
                        v-model="dni_busqueda" type="text" maxlength="100"
                        placeholder="POR DOCUMENTO DE IDENTIDAD / APELLIDOS" @input="Filtros" />
                </div>

                <!-- === TABLA === -->
                <div class="table-responsive mt-3">

                    <table class="table table-bordered table-sm text-nowrap  mb-0">
                        <thead>
                            <tr class="bg-solimano-table text-white text-center tamaño2 ">
                                <th>ID</th>
                                <th>CV</th>
                                <th>PERFIL PROFESIONAL</th>
                                <th>TIP. DOC.</th>
                                <th>NRO. DOC</th>
                                <th>APELLIDOS Y NOMBRES </th>
                                <th>UBIGEO</th>
                                <th>NACIONALIDAD</th>
                                <th>ESTADO</th>
                                <th>MOTIVO BLOQUEO</th>
                                <th style="min-width: 300px" >MENSAJE </th> <!-- MENSAJE 🔥 -->
                                <th>ACCIÓN</th>
                            </tr>
                        </thead>

                        <tbody v-if="dni_busqueda.trim().length > 0">
                            <tr v-if="loading">
                                <td colspan="12" class="text-center py-5">
                                    <div class="spinner-border text-primary" role="status"
                                        style="width: 3rem; height: 3rem;">
                                        <span class="visually-hidden">Cargando...</span>
                                    </div>
                                </td>
                            </tr>
                            <tr v-else
                                v-for="items in Respuesta.slice(Math.max(0, NUM_RESULTS - 16), NUM_RESULTS)"
                                :key="items.idPostulante" class="tamaños text-nowrap align-middle">

                                <!-- ID -->
                                <td class="fw-bold text-center">
                                    <div class="d-flex justify-content-center align-items-center gap-1">
                                        {{ items.idPostulante }}
                                    </div>
                                </td>

                                <!-- CV -->
                                <td class="text-center">
                                    <template v-if="items.posAdjunto != 1">
                                        <a :href="url + items.posAdjunto.slice(32)" target="_blank"
                                            class="btn btn-outline-primary btn-sm d-flex align-items-center justify-content-center gap-1">
                                            <i class="bi bi-download"></i> <span>CV</span>
                                        </a>
                                    </template>
                                    <span v-else class="text-muted">Sin CV</span>
                                </td>

                                <!-- PROFESIÓN -->
                                <td class="text-center">
                                    <i class="bi bi-award-fill text-warning me-1"></i>
                                    {{ items.posPerProfesional }}
                                </td>

                                <!-- TIPO DOC -->
                                <td class="text-center">
                                    <i class="bi bi-card-text text-info me-1"></i>
                                    {{ items.desTipDocumento }}
                                </td>

                                <!-- N° DOCUMENTO -->
                                <td class="text-center">
                                    <i class="bi bi-pin-angle-fill text-secondary me-1"></i>
                                    {{ items.posNroDocumento }}
                                </td>

                                <!-- APELLIDOS Y NOMBRE -->
                                <td class="text-center">
                                    <i class="bi bi-person-fill text-primary me-1"></i>
                                    {{ items.posApePaterno }} {{ items.posApeMaterno }} {{ items.posNombre }}
                                </td>

                                <!-- UBICACIÓN -->
                                <td class="text-center">
                                    <i class="bi bi-geo-alt-fill text-danger me-1"></i>
                                    {{ items.desDepartamento }} - {{ items.desProvincia }} - {{ items.desDistrito }}
                                </td>

                                <!-- NACIONALIDAD -->
                                <td class="text-center">
                                    <i class="bi bi-flag-fill text-success me-1"></i>
                                    {{ items.desNacionalidad }}
                                </td>

                                <!-- ESTADO -->
                                <td>
                                    <div class="d-flex align-items-center gap-2">
                                        <i class="bi bi-shield-check text-primary fs-7"></i>
                                        <!-- <select class="form-select form-select-sm w-auto flex-grow-1"
                                            @change="Estado($event)">
                                            <option disabled selected>{{ items.desEstado }}</option>
                                            <option v-for="EstadoStatuse in EstadoStatus" :key="EstadoStatuse.idParametro"
                                                :value="EstadoStatuse.parCorrelativo">
                                                {{ EstadoStatuse.parDescripcion }}
                                            </option>
                                        </select> -->
                                        <select
                                            class="form-select form-select-sm w-auto flex-grow-1"
                                            @change="Estado($event) , items.posEstado = $event.target.value"
                                            >
                                            <option disabled selected>{{ items.desEstado }}</option>
                                            <option
                                                v-for="estado in EstadoStatus.slice(3,4)"
                                                :key="estado.idParametro"
                                                :value="estado.parCorrelativo"
                                            >
                                                {{ estado.parDescripcion }}
                                            </option>
                                        </select>
                                    </div>
                                </td>

                                <!-- MOTIVO -->
                                <td>
                                    <div class="d-flex align-items-center gap-2">
                                        <i class="bi bi-exclamation-circle-fill text-warning fs-7"></i>
                                     <!-- form.posEstado -->
                                      <!-- v-model="motivoSeleccionado" -->
                                      
                                        <select 
                                            class="form-select form-select-sm w-auto flex-grow-1"
                                            :disabled="items.posEstado != '004'" @change="items.posMotBloqueo = $event.target.value">
                                            <option disabled selected value="">
                                                {{ estadoMotivo.length === 0 ? "Seleccionar motivo" :
                                                    items?.desMotBloqueo || "Sin motivo" }} 
                                            </option>
                                            <option v-for="(motivo, i) in estadoMotivo" :key="i.idParametro"
                                                :value="motivo.parCorrelativo">
                                                {{ motivo.parDescripcion }}
                                            </option>
                                        </select>
                                    </div>
                                </td>

                                <!-- MENSAJE -->
                                <td  >
                                    <div class="d-flex align-items-start gap-2 ">
                                        <i class="bi bi-chat-text-fill text-info fs-5 mt-1"></i>
                                        <!-- <textarea rows="2" maxlength="1000" class="form-control form-control-sm w-100"
                                            v-model="form.posComBloqueo" :disabled="form.posEstado != '001'"></textarea> -->

                                            <textarea
                                                v-model="items.posComBloqueo"
                                                rows="1"
                                                maxlength="1000"
                                                class="form-control form-control-sm flex-grow-1 py-auto my-auto"
                                                 style="
                                                            height: 20px;
                                                            padding-top: 0;
                                                            padding-bottom: 0;
                                                            line-height: 20px;
                                                                resize: none;
                                                        "
                                                :disabled="items.posEstado != '004'"
                                                >                                                
                                            </textarea>
                                    </div>
                                </td>


                                <!-- GUARDAR -->
                                <td class="text-center">
                                    <button
                                        class="btn btn-outline-success btn-sm d-flex align-items-center gap-1 mx-auto"
                                        @click="modificarPostulante(items)" :disabled="items.posEstado != '004'">
                                        <!-- !esRegistroActivo(items) -->
                                        <i class="bi bi-floppy-fill fs-5"></i>
                                        Guardar
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <EditarPostulantes class="mx-auto" v-if="!postulanteCondic" :numeroDocument="numeroDocument" />

        <NuevoPostulante class="mx-auto" v-if="!nuevoPostulante" />

    </div>
</template>

<script>
import NuevoPostulante from "@/components/ModSeleccion/Postulante/RegistrarPostulante.vue";
import EditarPostulantes from "@/components/ModSeleccion/Postulante/EditarPostulante.vue";
import Swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";

export default {
    name: "RestricciondePostulante",

    components: {
        EditarPostulantes,
        NuevoPostulante,
    },

    data() {
        return {
            motivoSeleccionado: "",
            message: "",
            selectores: "",
            estadoMotivo: [],
            combito: [],
            Respuesta: [],
            tabla1: true,
            retrocedere: "<<",
            avanzare: ">>",
            numeroDocument: Number,
            BotonTabla: false,
            postulanteCondic: true,
            adams: false,
            mostrarInput: true,
            nuevoPostulante: true,
            postulanteCondicion: true,
            dni_busqueda: "",
            prender: true,
            alerta: false,
            cerrarTable1: true,
            cerrarTable2: false,
            alertita: false,
            retro: false,
            avanzar: true,
            loading: false,
            NUM_RESULTS: 16, // Numero de resultados por página
            pag: 1, // Página inicial
            desEstado: "",
            debounceTimer: null, // 🕒 Timer para controlar la frecuencia de búsqueda
            // JSON a mostrar
            url: "http://190.81.170.6:8086/Documentos/CV/",

            form: {
                idUsuario: "",
                idPostulante: "",
                posTipDocumento: "",
                posNroDocumento: "",
                posUbigeo: "",
                posNombre: "",
                posApePaterno: "",
                posApeMaterno: "",
                posFecNacimiento: "",
                posGenero: "",
                posEstCivil: "",
                posTelefono: "",
                posTelAdicional: "",
                // CodProvincia:"",
                posMotBloqueo: "",
                posPais: "",
                posNacionalidad: "",
                posPerProfesional: "",
                posAdjunto: "1",
                posEstado: "",
                posOcupacion: "",
                posCorreo: "",
                posCanHijos: "",
                posDireccion: "",
                posHijosMen: "",
                posGradoAcademico: "",
                posEstudios: "",
                modPostulante: false,
                posEstadoConvoca: "",
                posComBloqueo: "",

                // posDatos:""
            },
        };
    },

    mounted() {
        this.form.idUsuario = localStorage.getItem("userId");

        this.axios.get("ParametroData/Parametro/7662").then((r) => {
            console.log(r.data);
            this.estadoMotivo = r.data;
        });
    },

    computed: {
        // ...mapGetters("listadoPostulante", ["Info", "Loader", "Tabla1"]),
        ...mapGetters("listadoPostulante", ["Postulante"]),
        ...mapGetters("parametros", ["EstadoStatus"]),
    },

    created() {
        this.cambiarEstadoNavbar();
    },

    methods: {
        ...mapActions("listadoPostulante", [
            "getAttributesPostulanteUsers",
            "getAttributesPostulante",
        ]),
        verificarMotivo() {
            console.log("🔍 Motivo seleccionado:", this.motivoSeleccionado);
            this.form.posMotBloqueo = this.motivoSeleccionado;
        },

        Filtros() {
            // 1. Limpiar el temporizador anterior cada vez que el usuario presiona una tecla
            clearTimeout(this.debounceTimer);

            if (this.dni_busqueda.length > 0) {
                this.tabla1 = false;
                this.loading = true; // Activar spinner inmediatamente para feedback visual
                this.Respuesta = [];

                // 2. Iniciamos un nuevo temporizador (500ms suele ser el tiempo ideal)
                this.debounceTimer = setTimeout(() => {
                    const currentDni = this.dni_busqueda;
                    const isNumeric = !isNaN(parseFloat(currentDni)) && isFinite(currentDni);

                    let apiUrl = isNumeric
                        ? `Postulante/BusquedaxDniPos?dni=${currentDni}`
                        : `Postulante/BusquedaxDniPos?apellido=${currentDni}`;

                    this.axios
                        .get(apiUrl)
                        .then((datos) => {
                            console.log("📥 Respuesta de la API:", datos.data);
                            // Solo actualizamos si el valor del input sigue siendo el mismo que cuando se disparó esta petición
                            if (currentDni === this.dni_busqueda) {
                                if (Array.isArray(datos.data) && datos.data.length > 0) {
                                    this.Respuesta = datos.data;
                                }
                            }
                        })
                        .catch((error) => {
                            console.error("Error al obtener datos:", error);
                        })
                        .finally(() => {
                            this.loading = false; // Detener spinner al terminar
                        });
                }, 500); 
            } else {
                this.tabla1 = true;
                this.Respuesta = [];
                this.loading = false; // por si se borró el DNI
            }
        },


        modificarPostulante(items) {
            console.log(items)
            // console.log("🧐 Estado actual de this.form:", this.form);
            // this.loading = true;
             let formData = new FormData();

             formData.append("IdPostulante", items.idPostulante);
             formData.append("PosTipDocumento", items.posTipDocumento);
             formData.append("PosNroDocumento", items.posNroDocumento);
             formData.append("PosNombre", items.posNombre);
             formData.append("PosApePaterno", items.posApePaterno);
             formData.append("PosApeMaterno", items.posApeMaterno);
             formData.append("PosFecNacimiento", items.posFecNacimiento);
             formData.append("PosGenero", items.posGenero);
             formData.append("PosEstCivil", items.posEstCivil);
             formData.append("PosTelefono", items.posTelefono);
             formData.append("PosTelAdicional", items.posTelAdicional);
             formData.append("PosPais", items.posPais);
             formData.append("PosUbigeo", items.posUbigeo);
             formData.append("PosNacionalidad", items.posNacionalidad);
             formData.append("PosPerProfesional", items.posPerProfesional);
             formData.append("idUsuario", this.form.idUsuario);
             formData.append("posMotBloqueo", items.posMotBloqueo);
             formData.append("PosEstado", items.posEstado);
             formData.append("PosOcupacion", items.posOcupacion);
             formData.append("PosCorreo", items.posCorreo);
             formData.append("PosCanHijos", items.posCanHijos);
             formData.append("PosDireccion", items.posDireccion);
             formData.append("PosHijosMen", items.posHijosMen);
             formData.append("PosGradoAcademico", items.posGradoAcademico);
             formData.append("PosEstudios", items.posEstudios);
             formData.append("PosAdjunto", items.posAdjunto);
             formData.append("ArchivoPos", items.posAdjunto);

             formData.append("modPostulante", items.modPostulante);
             formData.append("posEstadoConvoca", items.posEstadoConvoca);
             formData.append("posComBloqueo", items.posComBloqueo); // Archivo

            // formData.append("IdPostulante", this.form.idPostulante);
            // formData.append("PosTipDocumento", this.form.posTipDocumento);
            // formData.append("PosNroDocumento", this.form.posNroDocumento);
            // formData.append("PosNombre", this.form.posNombre);
            // formData.append("PosApePaterno", this.form.posApePaterno);
            // formData.append("PosApeMaterno", this.form.posApeMaterno);
            // formData.append("PosFecNacimiento", this.form.posFecNacimiento);
            // formData.append("PosGenero", this.form.posGenero);
            // formData.append("PosEstCivil", this.form.posEstCivil);
            // formData.append("PosTelefono", this.form.posTelefono);
            // formData.append("PosTelAdicional", this.form.posTelAdicional);
            // formData.append("PosPais", this.form.posPais);
            // formData.append("PosUbigeo", this.form.posUbigeo);
            // formData.append("PosNacionalidad", this.form.posNacionalidad);
            // formData.append("PosPerProfesional", this.form.posPerProfesional);
            // formData.append("idUsuario", this.form.idUsuario);
            // formData.append("posMotBloqueo", this.form.posMotBloqueo);

            // formData.append("PosEstado", this.form.posEstado);
            // formData.append("PosOcupacion", this.form.posOcupacion);
            // formData.append("PosCorreo", this.form.posCorreo);
            // formData.append("PosCanHijos", this.form.posCanHijos);
            // formData.append("PosDireccion", this.form.posDireccion);
            // formData.append("PosHijosMen", this.form.posHijosMen);
            // formData.append("PosGradoAcademico", this.form.posGradoAcademico);
            // formData.append("PosEstudios", this.form.posEstudios);
            // formData.append("PosAdjunto", this.form.posAdjunto);
            // formData.append("ArchivoPos", this.form.posAdjunto);

            // formData.append("modPostulante", this.form.modPostulante);
            // formData.append("posEstadoConvoca", this.form.posEstadoConvoca);
            // formData.append("posComBloqueo", this.form.posComBloqueo); // Archivo

            this.axios
                .put("Postulante/Modificar", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then((r) => {
                    if (r.data == true) {
                        Swal.fire(
                            "¡Éxito!",
                            "Postulante modificado correctamente.",
                            "success"
                        );
                    } else {
                        Swal.fire("Error", r.data, "error");
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                    Swal.fire(
                        "Error inesperado",
                        "Ocurrió un problema al modificar.",
                        "error"
                    );
                })
                .finally(() => {
                    setTimeout(() => {
                        this.loading = false; // ⏹ DETENER SPINNER
                    }, 800);
                });
        },

        esRegistroActivo(items) {
            return items.posEstado == "001" && items.posMotBloqueo == "000";
        },
        esRegistroInactivo(items) {
            return items.posEstado == "002" && items.posMotBloqueo == "000";
        },
        esRegistroBlacklist(items) {
            return items.posEstado == "002" && items.posMotBloqueo != "000";
        },

        toggleEstado(items) {
            if (this.esRegistroActivo(items)) {
                // Si está activo, lo cambia a inactivo
                items.posEstado = "002";
            } else if (this.esRegistroInactivo(items)) {
                // Si está inactivo, lo cambia a activo
                items.posEstado = "001";
            }
        },

        realizarAccionAlAceptar() {
            const from = {
                idUsuario: this.selectores,
            };
            this.axios.put(`Usuario/ModificarUsuario`, from).then((r) => {
                console.log(r.data);
            });
        },

        cambiarEstadoNavbar() {
            // Acción directa para cambiar el estado del navbar a true
            this.$store.dispatch("acciones/CambioNavbar", true);
        },
        Estado(event) {
            this.form.posEstado = event.target.value;
            this.form.posEstado !== "002"
                ? this.form.posMotBloqueo == "" &&
                this.form.posEstado == event.target.value
                : this.form.posEstado == event.target.value;

                // event.posEstado !== "002"
                // ? this.form.posMotBloqueo == "" &&
                // this.form.posEstado ==  event.posEstado
                // : this.form.posEstado == event.posEstado;
             console.log(this.form.posEstado);
        },

        listado() {
            this.tabla2 = false;
            this.BotonTabla = !this.BotonTabla;
            this.postulanteCondicion = true;
            this.postulanteCondic = true;
            this.nuevoPostulante = true;
            this.mostrarInput = true;
        },

        postulante() {
            this.BotonTabla = true;
            this.nuevoPostulante = false;
            this.postulanteCondicion = false;
            this.postulanteCondic = true;
            this.mostrarInput = false;
        },
        editar(nroDoc) {
            this.BotonTabla = true;

            // console.log(nroDoc);
            this.numeroDocument = nroDoc;
            this.postulanteCondic = false;
            this.postulanteCondicion = false;
            this.mostrarInput = false;
            // this.$router.push("/EditarListado/" + nroDoc);
            console.log(this.numeroDocument);

            this.axios
                .get(`Usuario/ListarUsuarioxdni?nroDocumento=${nroDoc}`)
                .then((r) => {
                    this.combito = r.data;
                    console.log(r.data);
                });
        },

        buscador() {
            this.adams = true;
        },

        eliminar(muere) {
            Swal.fire({
                title: "Deseas Eliminar",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire("Eliminado!", "con éxito.", "success");
                    this.axios.delete("Postulante/Eliminar/" + muere).then((datos) => {
                        console.log(datos);
                        this.dni_busqueda = "";
                        this.getAttributesPostulante();
                    });
                }
            });
        },

        // retroceder() {
        //   this.$router.push("/Dashboard");
        // },

        retroceso() {
            if (this.NUM_RESULTS === 16) {
                this.retro = false;
            } else {
                this.retro == true;
                this.NUM_RESULTS -= 16;
                this.pag -= 1;
            }
        },
        aumentar() {
            this.NUM_RESULTS += 16;
            this.pag += 1;
            if (this.NUM_RESULTS >= 16) {
                this.retro = true;
            } else {
                this.retro = false;
            }
            if (this.NUM_RESULTS > this.Info.length) {
                this.avanzar = false;
            }
            // console.log(this.NUM_RESULTS);
        },

        mandar(id) {
            this.$router.push("/usuarioinfo/" + id);
        },
    },
};
</script>

<style scoped>
.tituloResaltado {
    font-weight: 500;
    text-decoration: none;
    font-size: 1.23rem;
}

.boton-estiloPag {
    border: 1px solid rgb(199, 199, 199);
    background-color: white;
    color: rgb(32, 32, 32);
    padding: 0.6rem 1rem;
    border-radius: 0;
}

.boton-estiloCuadrado {
    padding: 0.2rem 0.55rem;
    cursor: pointer;
    /* Cambia el cursor a una mano */
}

.buscar-estiloCuadrado {
    border-radius: 0;
    font-size: 0.65rem;
    background-color: transparent;
    /* Fondo transparente */
}

.tabla-estiloCompreso {
    padding: 0.3rem 0.55rem;
}

textarea {
    width: 100%;
    /* Ocupa todo el espacio en la celda */
    height: 15em;
    /* Asegura 5 líneas de altura */
    padding: 10px;
    font-size: 16px;
    border: 1px solid white;
    border-radius: 5px;
    resize: none;
    background-color: white;
    /* Fondo oscuro */
    color: black;
    /* Texto blanco */
    display: block;
    /* Evita desbordes */
}

.boton-estiloCuadrado {
    padding: 0.2rem 0.55rem;
    cursor: pointer;
    /* Cambia el cursor a una mano */
}

.tamaño {
    font-size: 0.65rem;

    font-weight: 800;
    color: #002c5d;
}

.tamaños {
    font-size: 0.65rem;
}

.tamaño2 {
    font-size: 0.65rem;
    font-weight: 800;
}

.titulo {
    color: #0080c8;
    text-decoration: underline;
}

.bg-solimano {
    border-color: #0080c8;
    border-width: 2px;
}

.bg-solimano-table {
    background: #0080c8;
}

.btn-solimano {
    background: #0080c8;
}

.tituloColorMas {
    /* color: #002c5d; */
    font-weight: 500;
    text-decoration: none;
    font-size: 1.23rem;
}

.quitar {
    font-weight: 500;
}

.medida {
    width: 420px;
    height: 44px;
    border-color: #e9e9e9;
}

.medidaFecha {
    width: 160px;
    height: 44px;
    border-color: #e9e9e9;
}
.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}
.reducirTamaño {
  font-size: 0.65rem;
}
</style>